import { z } from 'zod/mini';
import { listSearchSchema } from '../list/search/list-search-schema';
import type { processDefinitionsQueryFragment$data } from './__generated__/processDefinitionsQueryFragment.graphql';

type TProcessDefinitionKeys = keyof processDefinitionsQueryFragment$data['content'][number];

export const processDefinitionsSearchSchema = z.intersection(
    listSearchSchema,
    z.object({
        sortBy: z.optional(
            z.catch(
                z.enum<TProcessDefinitionKeys[]>([
                    'id',
                    'definitionKey',
                    'definitionName',
                    'definitionVersion',
                    'listName',
                    // 'site',
                    'status',
                ]),
                'id'
            )
        ),
    })
);

export type TProcessDefinitionsSearchSchema = z.infer<typeof processDefinitionsSearchSchema>;
